import {useEffect} from 'react'

const useDescription = (desc)=>{
    useEffect(()=>{
        document.querySelector('meta[name="description"]').setAttribute("content", desc);
    }, [desc])
}

export default useDescription;